import React from "react";
import { Card } from "antd";

const ApprovedLeaveRequestCard = (props) => {
  const {
    name,
    role,
    duration,
    leavePeriod,
    approvedBy,
    leaveType, 
    approvalDate,
    employeeId,
  } = props;

  return (
    <Card
      className="rounded-2xl border border-green-200 overflow-y-auto space-y-4 pr-2 mb-2"
    >
      <div className="flex justify-between items-start relative">
        <span className={`absolute right-5 text-xs status-indicator ${leaveType.toLowerCase().replace(/\s+/g, "-")}`}>
          {leaveType}
        </span>

        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 flex items-center justify-center rounded-full bg-green-100 text-green-700 font-semibold">
            {name ? name.split(" ").map((n) => n[0]).join("") : ""}
          </div>
          <div>
            <div className="flex flex-row gap-2">
              <h3 className="font-semibold text-gray-800 ">{name}</h3>
              <span className="status-indicator normal text-[10px] px-2">{employeeId}</span>
              <span className="status-indicator approved text-[10px] px-2">Approved</span>
            </div>
         
            <div className="flex items-center text-gray-600 text-sm">
              {role}
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-2">
        <div>
          <p className="text-xs text-gray-500 mb-1">Duration</p>
          <div className="text-sm font-medium">
            {duration}
          </div>
        </div>
        <div>
          <p className="text-xs text-gray-500 mb-1">Leave Period</p>
          <div className="gap-1 text-sm font-medium">
            {leavePeriod}
          </div>
        </div>
        <div>
          <p className="text-xs text-gray-500 mb-1">Approved By</p>
          <div className="gap-1 text-sm font-medium">
            {approvedBy}
          </div>
        </div>
        <div>
          <p className="text-xs text-gray-500 mb-1">Approved On</p>
          <span className="text-sm font-medium">{approvalDate}</span>
        </div>
      </div>
    </Card>
  );
};

export default ApprovedLeaveRequestCard;
